import { createMuiTheme } from '@material-ui/core/styles';

const iddMuiTheme = createMuiTheme({
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '"IBM Plex Sans"',
            '"Karla"',
            'sans-serif'
        ].join(','),
    }
})

export default iddMuiTheme


// WEBPACK FOOTER //
// ./src/IddMuiTheme.js